import {
  computed,
  effect,
  EnvironmentInjector,
  inject,
  Injectable,
  runInInjectionContext,
  untracked,
} from '@angular/core';

import { LangService } from '@reforgium/presentia';
import { DictStore } from '@reforgium/statum';

import { environment } from 'constants/environment';

import { DictItemDto, DocumentCategoriesDto, DocumentStatusDto } from 'entities/dict.model';
import { DocumentLangs } from 'entities/document.model';

@Injectable({ providedIn: 'root' })
export class DictService {
  private langService = inject(LangService);
  private env = inject(EnvironmentInjector);

  private apiUrl = `${environment.API_ENDPOINT}/metadata`;

  types = this.initTypes();
  categories = this.initCategories();
  statuses = this.initStatuses();

  lang = {
    options: computed(() => [
      { label: 'Русский', value: DocumentLangs.RU },
      { label: 'Кыргызский', value: DocumentLangs.KY },
    ]),
  };

  fileTypes = {
    options: computed(() => [
      { label: 'Оригинал', value: 'ORIGINAL' },
      { label: 'Обработанный', value: 'PROCESSED' },
    ]),
  };

  fileFormats = {
    options: computed(() => [
      { label: 'PDF ', value: 'PDF' },
      { label: 'Word (DOCX)', value: 'DOCX' },
      { label: 'Word (DOC)', value: 'DOC' },
    ]),
  };

  constructor() {
    effect(() => {
      this.langService.currentLang();

      untracked(() => {
        this.types = this.initTypes();
        this.categories = this.initCategories();
        this.statuses = this.initStatuses();
      });
    });
  }

  initTypes() {
    const lang = this.langService.currentLang();

    return runInInjectionContext(
      this.env,
      () =>
        new DictStore<DictItemDto>(`${this.apiUrl}/document-types`, `document-types-${lang}`, {
          presetFilters: { lang: lang.toUpperCase() },
        }),
    );
  }

  initStatuses() {
    const lang = this.langService.currentLang();

    return runInInjectionContext(
      this.env,
      () =>
        new DictStore<DocumentStatusDto>(`${this.apiUrl}/document-statuses`, `document-statuses-${lang}`, {
          presetFilters: { lang: lang.toUpperCase() },
        }),
    );
  }

  initCategories() {
    const lang = this.langService.currentLang();

    return runInInjectionContext(
      this.env,
      () =>
        new DictStore<DocumentCategoriesDto>(`${this.apiUrl}/document-categories`, `document-categories-${lang}`, {
          presetFilters: { lang: lang.toUpperCase() },
          labelKey: 'name',
          valueKey: 'id',
          cacheStrategy: 'memory',
        }),
    );
  }
}
